import { getSerializedDualGrantorOption } from '@/hooks/useDualGrantorOptions';
import { isHypotheticalDraftEntityType } from '@/modules/entities/draftEntities/draftEntities.constants';
import { getCreateDraftEntityInput } from '@/modules/entities/draftEntities/getCreateDraftEntityInput';
import { AugmentedCreateEntityInput } from '@/types/schema';

import { MapHypotheticalInsuranceToDataInput } from '../HypotheticalILITModal.utils';

export function getWithDestinationEntity({
  formData,
  contextData: { householdId },
  primaryClients,
}: MapHypotheticalInsuranceToDataInput): {
  withDestinationEntity: AugmentedCreateEntityInput | undefined;
  destinationEntityID?: string | undefined;
  clearDestinationEntity?: boolean | undefined;
  errors?: string[];
} {
  const {
    destinationEntityGrantor,
    destinationEntityName: draftEntityName,
    destinationEntityType: draftEntityType,
    destinationEntityId,
    _createANewHypotheticalTrust,
  } = formData;

  if (!_createANewHypotheticalTrust) {
    if (!destinationEntityId) {
      return {
        withDestinationEntity: undefined,
        errors: ['Destination entity is required'],
      };
    }
    return {
      withDestinationEntity: undefined,
      destinationEntityID: destinationEntityId,
      clearDestinationEntity: true,
    };
  }

  if (!draftEntityType) {
    return {
      withDestinationEntity: undefined,
      errors: ['Destination entity type is required'],
    };
  }

  if (!isHypotheticalDraftEntityType(draftEntityType)) {
    return {
      withDestinationEntity: undefined,
      errors: ['Destination entity type is not supported'],
    };
  }

  const draftEntityGrantorId = getSerializedDualGrantorOption(
    destinationEntityGrantor,
    primaryClients
  ).join(',');

  return {
    withDestinationEntity: getCreateDraftEntityInput({
      draftEntityType,
      draftEntityName,
      draftEntityGrantorId,
      householdId,
    }),
    clearDestinationEntity: true,
  };
}
